import { createReducer } from "redux-create-reducer";
import callAPI from "../../../utils/callAPI";

export const REQUEST_SELECTION_DATA = "REQUEST_SELECTION_DATA";
export const REQUEST_SELECTION_DATA_SUCCESS = "REQUEST_SELECTION_DATA_SUCCESS";
export const REQUEST_SELECTION_DATA_FAILURE = "REQUEST_SELECTION_DATA_FAILURE";
export const REQUEST_SUGGEST_PRODUCT = "REQUEST_SUGGEST_PRODUCT";
export const REQUEST_SUGGEST_PRODUCT_SUCCESS =
  "REQUEST_SUGGEST_PRODUCT_SUCCESS";
export const REQUEST_SUGGEST_PRODUCT_FAILURE =
  "REQUEST_SUGGEST_PRODUCT_FAILURE";
export const REQUEST_SUGGEST_TABLE_PRODUCT_SELECTED =
  "REQUEST_SUGGEST_TABLE_PRODUCT_SELECTED";
export const SET_SELECTIONS_DATA = "SET_SELECTIONS_DATA";
export const SUBMIT_SUGGEST_PRODUCT = "SUBMIT_SUGGEST_PRODUCT";
export const CLEAR_SUGGEST_PRODUCT = "CLEAR_SUGGEST_PRODUCT";
export const UPDATE_QUANTITY_SUGGEST_PRODUCT =
  "UPDATE_QUANTITY_SUGGEST_PRODUCT";
export const ACTION_ADD_TO_CART = "ACTION_ADD_TO_CART";

export const REQUEST_SEND_BOQ         = "REQUEST_SEND_BOQ";
export const REQUEST_SEND_BOQ_SUCCESS = "REQUEST_SEND_BOQ_SUCCESS";
export const REQUEST_SEND_BOQ_FAILURE = "REQUEST_SEND_BOQ_FAILURE";

export const UPDATE_QUANTITY_CART_INFORMATION = "UPDATE_QUANTITY_CART_INFORMATION";
export const UPDATE_CART_INFORMATION = "UPDATE_CART_INFORMATION";
export const CLEAR_CART_INFORMATION = "CLEAR_CART_INFORMATION";

const defaultState = {
  selectionData: {
    vavTypeList: [],
    diffuserList: [],
    outletOptions: [],
    flexibleDuctList: [],
  },
  vavTypeListFormated: {},
  productTable: [],
  productTableSelected: [],
  cartInformation: {
    projectInformation: {},
    products: [],
  },
  clearProductTable: 1,
  dataSubmitSuggestProduct: [],
  fetchingProductTableData: false,
  failedFetchingProductTableData: false,
  fetchingSelectionData: false,
  failedFetchingSelectionData: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_SELECTION_DATA]: (state, action) => ({
    ...state,
    fetchingSelectionData: true,
    failedFetchingSelectionData: false,
  }),
  [REQUEST_SELECTION_DATA_SUCCESS]: (state, action) => ({
    ...state,
    selectionData: {
      vavTypeList: action.payload.data.vavTypeList,
      diffuserList: action.payload.data.diffuserList.map((item) => {
        return { value: item, label: item };
      }),
      outletOptions: action.payload.data.outletOptions.map((item) => {
        return { value: item, label: item };
      }),
      flexibleDuctList: action.payload.data.flexibleDuctList.map((item) => {
        return { value: item, label: item };
      }),
    },
    fetchingSelectionData: false,
    failedFetchingSelectionData: false,
  }),
  [REQUEST_SELECTION_DATA_FAILURE]: (state, action) => ({
    ...state,
    fetchingProducts: false,
    failedFetchingSelectionData: true,
  }),
  [REQUEST_SUGGEST_PRODUCT]: (state, action) => ({
    ...state,
    fetchingProductTableData: true,
    failedFetchingProductTableData: false,
  }),
  [REQUEST_SUGGEST_PRODUCT_SUCCESS]: (state, action) => ({
    ...state,
    productTable: action.payload.data,
    fetchingProductTableData: false,
    failedFetchingProductTableData: false,
  }),
  [REQUEST_SUGGEST_PRODUCT_FAILURE]: (state, action) => ({
    ...state,
    fetchingProductTableData: false,
    failedFetchingProductTableData: true,
  }),
  [REQUEST_SUGGEST_TABLE_PRODUCT_SELECTED]: (state, action) => ({
    ...state,
    productTableSelected: action.payload,
  }),
  [SUBMIT_SUGGEST_PRODUCT]: (state, action) => ({
    ...state,
    dataSubmitSuggestProduct: action.payload,
    cartInformation: {
      ...state.cartInformation,
      projectInformation: {
        project: action.payload.project,
        consultance: action.payload.consultance,
        name: action.payload.name,
        email: action.payload.email,
        phone: action.payload.phone,
        location: action.payload.location,
      },
    },
  }),
  [ACTION_ADD_TO_CART]: (state, action) => ({
    ...state,
    cartInformation: {
      ...state.cartInformation,
      products: state.cartInformation.products.concat(action.payload),
    },
  }),
  [CLEAR_SUGGEST_PRODUCT]: (state, action) => ({
    ...state,
    productTable: [],
    productTableSelected: [],
  }),
  [CLEAR_CART_INFORMATION]: (state, action) => ({
    ...state,
    cartInformation: {
      projectInformation: {},
      products: [],
    }
  }),
  [UPDATE_QUANTITY_SUGGEST_PRODUCT]: (state, action) => ({
    ...state,
    productTable: action.payload,
  }),
  [UPDATE_QUANTITY_CART_INFORMATION]: (state, action) => ({
    ...state,
    productTable: action.payload,
  }),
  [UPDATE_CART_INFORMATION]: (state, action) => ({
    ...state,
    cartInformation: {
      ...action.payload
    },
  }),
  [SET_SELECTIONS_DATA]: (state, action) => ({
    ...state,
    vavTypeListFormated: action.payload,
  }),
});

export default reducer;
export const namespace = "order";

export const setSelections = (payload) => ({
  type: SET_SELECTIONS_DATA,
  payload,
});

export const setTableProductSelected = (payload) => ({
  type: REQUEST_SUGGEST_TABLE_PRODUCT_SELECTED,
  payload,
});

export const submitSuggestProduct = (payload) => ({
  type: SUBMIT_SUGGEST_PRODUCT,
  payload,
});

export const clearSuggestProduct = (payload) => ({
  type: CLEAR_SUGGEST_PRODUCT,
  payload,
});

export const updateQuantitySuggestProduct = (payload) => ({
  type: UPDATE_QUANTITY_SUGGEST_PRODUCT,
  payload,
});

export const updateQuantityCartInformation = (payload) => ({
  type: UPDATE_QUANTITY_CART_INFORMATION,
  payload,
});

export const updateCartInformation = (payload) => ({
  type: UPDATE_CART_INFORMATION,
  payload,
});

export const clearCartInformation = (payload) => ({
  type: CLEAR_CART_INFORMATION,
  payload,
});

export const actionAddToCart = (payload) => ({
  type: ACTION_ADD_TO_CART,
  payload,
});

export const getSelectionData = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: "get",
    apiPath: "/filter-list",
    actionTypes: [
      REQUEST_SELECTION_DATA,
      REQUEST_SELECTION_DATA_SUCCESS,
      REQUEST_SELECTION_DATA_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const suggestProduct = (params) => async (dispatch, getState) => {
  return await callAPI({
    method: "post",
    apiPath: "/suggest-product",
    actionTypes: [
      REQUEST_SUGGEST_PRODUCT,
      REQUEST_SUGGEST_PRODUCT_SUCCESS,
      REQUEST_SUGGEST_PRODUCT_FAILURE,
    ],
    variables: {
      ...params,
    },
    dispatch,
    getState,
  });
};

export const sendBOQ = (params) => async (dispatch, getState) => {
  return await callAPI({
    method: "post",
    apiPath: "/send-boq",
    actionTypes: [
      REQUEST_SEND_BOQ,
      REQUEST_SEND_BOQ_SUCCESS,
      REQUEST_SEND_BOQ_FAILURE,
    ],
    variables: {
      ...params,
    },
    dispatch,
    getState,
  });
};
